import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import logger from './logger';

import {
  getStore,
  injectAsyncReducer,
  injectAsyncSagas,
  removeAsyncReducer,
  removeAsyncSagas,
} from '../../common/redux/store-utils';

function registerState(app) {
  // async add reducers
  if (app.reducers) {
    injectAsyncReducer(getStore(), app.namespace, app.reducers);
  }

  // async add sagas
  if (app.sagas) {
    injectAsyncSagas(app.sagas);
  }
}

function deregisterState({ namespace, sagas }) {
  //TODO explore alternatives, currently putting on a delay so rerenders don't occur after this has unmounted leading to state reads from state that is no longer there
  setTimeout(() => {
    removeAsyncReducer(namespace);

    if (sagas) {
      removeAsyncSagas(sagas);
    }
  }, 2000);
}

const createReactApp = ({ namespace, sagas, reducer, component, mountTo }) => {
  // this element is added to the page in ngx.core.js
  logger.error('createReactApp: You must provide a "mountTo" attribute', !mountTo);

  const _mountToNode = document.getElementById(mountTo);

  logger.error(
    'createReactApp: The node you are trying to mount your app to does not exist in the current DOM',
    !_mountToNode
  );
  logger.error('createReactApp: You must provide a "namespace" attribute', !namespace);
  logger.warn('createReactApp: You have not provided a "component"', !component);

  const store = getStore();
  const appMountNodeId = _createMountNodeId(namespace);

  // reducer must come first
  if (reducer) injectAsyncReducer(store, namespace, reducer);
  if (sagas) injectAsyncSagas(sagas);

  const mountNode = document.createElement('div');
  mountNode.setAttribute('id', appMountNodeId);

  _mountToNode.appendChild(mountNode);
  ReactDOM.render(<Provider store={store}>{component}</Provider>, document.getElementById(appMountNodeId));
};

const destroyReactApp = ({ namespace, sagas, mountTo }) => {
  logger.error('destroyReactApp: You must provide a "mountTo" attribute', !mountTo);

  const _mountToNode = document.getElementById(mountTo);

  logger.error(
    'destroyReactApp: The node you are trying to remove your app from to does not exist in the current DOM',
    !_mountToNode
  );
  logger.error('destroyReactApp: You must provide a "namespace" attribute', !namespace);

  const appMountNodeId = _createMountNodeId(namespace);

  const element = document.getElementById(appMountNodeId);
  ReactDOM.unmountComponentAtNode(element);
  element.parentNode.removeChild(element);

  // TODO How we deregister redux needs to be looked at
  // deregisterState({ namespace, sagas });
};

function _createMountNodeId(namespace) {
  return `${namespace}-app`;
}

export default { registerState, createReactApp };
export { registerState, createReactApp, deregisterState, destroyReactApp };
